import { c as _c } from "react/compiler-runtime";
import React from "react";
interface ArrowIconProps {
  size?: number;
  className?: string;
  rotate?: number;
}
const ArrowIcon = t0 => {
  const $ = _c(7);
  const {
    size: t1,
    className,
    rotate: t2
  } = t0;
  const size = t1 === undefined ? 24 : t1;
  const rotate = t2 === undefined ? 0 : t2;
  const t3 = `dynamic-size ${className}`;
  const t4 = `rotate(${rotate}deg)`;
  let t5;
  if ($[0] !== size || $[1] !== t4) {
    t5 = {
      "--width": size,
      "--height": size,
      transform: t4
    };
    $[0] = size;
    $[1] = t4;
    $[2] = t5;
  } else {
    t5 = $[2];
  }
  const t6 = t5 as React.CSSProperties;
  let t7;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t7 = <path d="M6 12L12.3333 6L18.6667 12H14.6667V18H10V12H6Z" fill="currentColor" stroke="currentColor" strokeWidth="1.33333" strokeLinecap="round" strokeLinejoin="round" />;
    $[3] = t7;
  } else {
    t7 = $[3];
  }
  let t8;
  if ($[4] !== t3 || $[5] !== t6) {
    t8 = <svg className={t3} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" style={t6}>{t7}</svg>;
    $[4] = t3;
    $[5] = t6;
    $[6] = t8;
  } else {
    t8 = $[6];
  }
  return t8;
};
export default ArrowIcon;